import { render, staticRenderFns } from "./OnlinePay.vue?vue&type=template&id=6ab1f954"
import script from "./OnlinePay.vue?vue&type=script&lang=js"
export * from "./OnlinePay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports